import { ui, buttonsMap } from "./buttons";
import { columnName } from "../helpers/column_names";

function isRowColAction(id) {
	return id.indexOf("-row") !== -1 || id.indexOf("-column") !== -1;
}

export function normalizeAction(action){
	// [fixme] maybe the better approach is to handle new ids as action-group
	if (isRowColAction(action.id)) {
		const parts = action.id.split("-");
		action.id = parts[0];
		if (!action.group) action.group = parts[1];
		if (action.id === "show") action.neighbors = true;
	}
}

export function getMenuLabel(id, action){
	if (!id) return ""; // separator
	if (action && action !== "format") {
		id = `${action}-${id}`;
	}
	if (action == "format" && isRowColAction(id)) {
		id = `format-${id.split("-")[0]}`;
	}
	const locale = webix.i18n.spreadsheet;
	return locale.menus[id] || locale.actions[id] || locale.labels[id] || id;
}

export function sortOptionTemplate(obj, view){
	const area = view._table.getSelectArea();
	const selected = { column: 1, row: 1 };
	if (area && area.start) {
		selected.column = area.start.column;
		selected.row = area.start.row;
	}
	selected.columnName = columnName(selected.column);
	return webix.template(obj.value)(selected);
}

export function toolbarButtons(view, structure){
	const checkButtons = function(cells){
		for (let i = 0; i < cells.length; i++){
			const name = cells[i].$button;
			if (name) {
				const base = buttonsMap[name] ? buttonsMap[name](view) : ui.iconButton({ name });
				webix.extend(cells[i], base);
				if(base.options) cells[i].options = base.options;
			}
			
			if (cells[i].rows)
				checkButtons(cells[i].rows);
			if (cells[i].cols)
				checkButtons(cells[i].cols);
		}
	};
	checkButtons(structure);
	return structure;
}

export function getButtons(view, structure){
	const config = [];
	for (let block in structure){
		config.push(elementsBlock(view, block, structure[block]));
		config.push(ui.separator());
	}
	return config;
}

function blockColumns(view, buttons){
	const cols = [];
	for (let i = 0; i < buttons.length; i++){
		const name = buttons[i];
		if (typeof name == "object"){
			cols.push(name);
		} else {
			const base = buttonsMap[name] ? buttonsMap[name](view) : ui.iconButton({ name });
			cols.push(base);
		}
	}
	return cols;
}

function elementsBlock(view, title, columns){
	return {
		rows:[
			{
				padding:2,
				cols:[{
					margin: 2,
					cols: blockColumns(view, columns)
				}]
			},
			ui.title({ title })
		]
	};
}